var ScrollAnimate = () => {
    const isString = e => "string" == typeof e;
    const setClassName = (element, prevClass, newClass = "") => {
        element.className = `${prevClass} ${newClass}`.trim();
    };

    return {
        isInView: ({ top, bottom }) =>
            top < window.innerHeight && bottom > 0,

        run(element, { value: params, modifiers }, { isUpwards, previousClassName = "" }) {
            if (isString(params)) {
                return setClassName(element, previousClassName, params);
            }

            const hasBothDirections = params.down && params.up;
            const classesDiffer = (a = "", b = "") => a.trim() !== b.trim();

            if (hasBothDirections || classesDiffer(element.className, previousClassName)) {
                const className = isUpwards ? params.up : params.down;
                return setClassName(element, previousClassName, className);
            }

            const shouldReset = modifiers.repeat && (
                (isUpwards && params.down) || (!isUpwards && params.up)
            );

            if (shouldReset) {
                return setClassName(element, previousClassName);
            }
        }
    }
};

const index = {
    ScrollAnimate,
    install(Vue) {
        let observer = null;
        let lastScrollY = window.pageYOffset;
        let isUpwards = false;

        // 监听滚动方向（性能开销很小）
        window.addEventListener('scroll', () => {
            const currentScrollY = window.pageYOffset || document.documentElement.scrollTop;
            isUpwards = currentScrollY < lastScrollY;
            lastScrollY = currentScrollY <= 0 ? 0 : currentScrollY;
        }, { passive: true });

        Vue.directive("animate-onscroll", {
            inserted(element, binding) {
                const animate = ScrollAnimate();
                const previousClassName = element.className;

                // 确保元素有初始样式
                element.style.opacity = '0';
                element.style.transition = 'opacity 0.3s, transform 0.3s';

                // 创建 IntersectionObserver（单例模式）
                if (!observer) {
                    observer = new IntersectionObserver(
                        (entries) => {
                            entries.forEach(entry => {
                                const { target, isIntersecting, intersectionRatio } = entry;

                                // 获取存储的数据
                                const data = target._animateData;
                                if (!data) return;

                                const { animate, previousClassName } = data;

                                if (isIntersecting || intersectionRatio > 0) {
                                    // 元素进入视口
                                    animate.run(
                                        target,
                                        binding,
                                        {
                                            isUpwards,
                                            previousClassName
                                        }
                                    );
                                    target.style.opacity = '1';
                                    target.style.transform = 'translateY(0)';
                                } else if (binding.modifiers.repeat) {
                                    // 元素离开视口且需要重复动画
                                    animate.run(
                                        target,
                                        binding,
                                        {
                                            isUpwards,
                                            previousClassName
                                        }
                                    );
                                    target.style.opacity = '0';
                                    target.style.transform = 'translateY(20px)';
                                }
                            });
                        },
                        {
                            threshold: 0.1, // 元素可见10%时触发
                            rootMargin: '0px 0px -50px 0px' // 提前50px触发
                        }
                    );
                }

                // 存储数据到元素上
                element._animateData = {
                    animate,
                    previousClassName,
                    binding
                };

                // 开始观察元素
                observer.observe(element);
            },

            unbind(element) {
                // 停止观察元素
                if (observer) {
                    observer.unobserve(element);
                }
                // 清理数据
                delete element._animateData;
            }
        });
    }
};

export default index;
